module.exports = __webpack_public_path__ + "img/sec1_2.2f69152c.png";